export const getKeyPathFromUrl = (url) => {
    const sellerPos = url.indexOf("seller/");

    if (sellerPos !== -1) {
        return url.slice(sellerPos);
    } else {
        const protocolEnd = url.indexOf("://") + 3;
        const firstSlash = url.indexOf("/", protocolEnd);

        if (firstSlash !== -1) {
            return url.slice(firstSlash + 1);
        } else {
            return "";
        }
    }
};
